( function ($) {
    $(window).load(function () {
        //fancybox
        $('.fancy').fancybox({
            afterLoad: function (el) {
                if (typeof el.current !== 'undefined'
                    && typeof el.current.src !== 'undefined'
                    && typeof pannellum_div_ids !== 'undefined') {
                    //360 images
                    var divToMatch = el.current.src.replace('#', '');
                    for (var i = 0; i < pannellum_div_ids.length; i++) {
                        if (pannellum_div_ids[i] === divToMatch) {
                            pannellum.viewer(pannellum_div_ids[i], {
                                "type": "equirectangular",
                                "panorama": pannellum_image_paths[i],
                                "autoLoad": true,
                                "compass": true
                            });
                        }
                    }
                }

            }
        });
    });
}(jQuery) );
